<template>
  <div class="my">
    <mt-header title="修改邮箱" class="reftitle">
      <mt-button slot="left" icon="back" @click="goback">返回</mt-button>
    </mt-header>
    <div v-if="showStatus">
      <div class="yzmposition">
      <mt-field label="验证码" placeholder="请输入原邮箱验证码" type="email" v-model="oldEmailCode"></mt-field>
      </div>
      <div class="edityzmdiv">
        <button class="fr codebtn" :class="{cliac:flag1}" @click="getOldCode()" v-bind:disabled="flag1">{{codeValue1}}
        </button>
      </div>
      <div class="loginbtdiv">
        <mt-button class="login-btn" size="large" type="primary" @click="validateOldEmail()">保&nbsp;&nbsp;存</mt-button>
      </div>
    </div>
    <div v-if="!showStatus">
      <mt-field label="邮箱帐号" placeholder="请输入邮箱帐号" type="email" v-model="loginCode"></mt-field>
      <div class="yzmposition">
      <mt-field label="验证码" placeholder="请输入新邮箱验证码" type="email" v-model="newEmailCode"></mt-field>
      </div>
      <div class="edityzmdiv">
        <button class="fr codebtn" :class="{cliac:flag}" @click="getCode()" v-bind:disabled="flag">{{codeValue}}
        </button>
      </div>
      <div class="loginbtdiv">
        <mt-button class="login-btn" size="large" type="primary" @click="sure()">保&nbsp;&nbsp;存</mt-button>
      </div>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import cheader from '@/components/header';
  export default {
    data () {
      return {
        count: 60,
        codeValue: '获取验证码',
        flag: false,
        outTimer: '',
        count1: 60,
        codeValue1: '获取验证码',
        flag1: false,
        outTimer1: '',
        isShow: true,
        loginCode: "",
        oldEmailCode: "",
        newEmailCode: "",
        oldMail: "",
        showStatus: true
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      validateOldEmail: function () {
        if (this.oldEmailCode == "") {
          this.$toast('验证码不可以为空');
          return;
        }

        this.$http.post(
          domain("_nextValidateOldEmail"), {
            mobileOremail: this.oldMail,
            mobileCode: this.oldEmailCode,
            mobileType: "9"
          },
          {emulateJSON: true}
          )
          .then(function (response) {
              //接口返回数据
              var code = response.data.code;
              if (code == "1") {
                this.showStatus = false;
              } else {
                this.$toast("绑定失败.");
              }
            }, function (error) {
              console.log(error)
              //Toast("数据获取响应异常.")

            }
          )
      },
      valiateData: function () {
        if (this.loginCode == "") {
          this.$toast('邮箱不可以为空.');
          return false;
        }
        var mailReg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
        if (!mailReg.test(this.loginCode)) {
          Toast("邮箱格式不正确.");
          return false;
        }

        if (this.newEmailCode == "") {
          this.$toast('验证码不可以为空');
          return false;
        }
        return true;
      },
      sure: function () {
        var flag = this.valiateData();
        if (!flag) {
          return;
        }
        this.$http.post(
          domain("_nextEmail"), {
            email: this.loginCode.trim(),
            mobileCode: this.newEmailCode.trim()
          },
          {emulateJSON: true}
          )
          .then(function (response) {
              //接口返回数据
              var code = response.data.code;
              if (code == "1") {
                let instance = Toast({
                  message: '修改成功'
                });
                setTimeout(function () {
                  instance.close();
                  history.go(-1); //后退1页
                }, 2000);
              }else if (code == "2"){
                this.$toast("验证码错误.");
              } else {
                this.$toast("绑定失败.");
              }
            }, function (error) {
              console.log(error)
              //Toast("数据获取响应异常.")

            }
          )
      },
      getCode: function () {
        if (this.loginCode == "") {
          this.$toast('邮箱账号不可以为空.');
          return;
        }
        this.$http.post(
          domain("_mailyzm"), {
            loginCode: this.loginCode,
            mailType: "10"
          },
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            var msg = response.body.msg;
            if (msg == '1') {
              this.$toast('验证码已发送,请查收');
              this.settime();
            } else {
              this.$toast('获取验证码失败,请稍后重试');
            }
          }, function (error) {
          })
      },
      getOldCode: function () {
        this.$http.post(
          domain("_mailyzm"), {
            loginCode: this.oldMail,
            mailType: "9"
          },
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            var msg = response.body.msg;
            if (msg == '1') {
              this.$toast('验证码已发送至您现有邮箱,请查收');
              this.settime1();
            } else {
              this.$toast('获取验证码失败,请稍后重试');
            }
          }, function (error) {
          })
      },
      settime: function () {
        var that = this;
        if (this.count == 0) {
          this.count = 60;
          this.flag = false;
          this.codeValue = '获取验证码';
          if (this.outTimer != null) {
            this.outTimer = null;
            return;
          }
        }
        this.flag = true;
        this.count--;
        this.codeValue = "重新发送(" + this.count + "s)";
        this.outTimer = setTimeout(function () {
          that.settime()
        }, 1000);
      },
      settime1: function () {
        var that = this;
        if (this.count1 == 0) {
          this.count1 = 60;
          this.flag1 = false;
          this.codeValue1 = '获取验证码';
          if (this.outTimer1 != null) {
            this.outTimer1 = null;
            return;
          }
        }
        this.flag1 = true;
        this.count1--;
        this.codeValue1 = "重新发送(" + this.count1 + "s)";
        this.outTimer1 = setTimeout(function () {
          that.settime1()
        }, 1000);
      },
      initParams(){
        this.oldMail = this.$route.params.mail;
      }
    },
    components: {
      cheader
    }
    ,
    mounted: function () {
      this.initParams();
    }
  }
</script>
<style>
  .my {
    height: 100%;
    background-color: #f0f0f0;
  }

  .my .mint-cell-text {
    color: #5d5d5d;
  }

  .my .mint-cell-wrapper {
    background-size: 0px;
  }

  .my .mint-cell {
    border-top: 10px solid #f0f0f0;
  }

  .my .mint-field .mint-cell-title{
    width: 75px;
  }

  .spwd {
    position: absolute;
    left: 100%;
    margin-left: -40px;
    top: 20px;
  }

  .bottomlogin {
    margin-top: 10px;
    padding: 0 12px;
  }

  .edityzmdiv {
    width: 100%;
    height: 30px;
    position: relative;
  }

  .edityzmdiv .codebtn {
    display: block;
    cursor: pointer;
    color: #1f74d8;
    position: absolute;
    z-index: 2;
    width: 95px;
    height: 47px;
    top: -48px;
    left: 100%;
    margin-left: -102px;
    text-align: center;
    border: 0;
    background-color: #ffffff;
  }

  .loginbtdiv {
    padding: 0 10px;
  }

  .cliac {
    color: #7d7d7d;
  }
</style>




// WEBPACK FOOTER //
// src/module/my/EditEmail.vue